import { DEFAULT_NEW_WORDS_PER_DAY, Profile } from '@lingoping/core';

export const MIN_NEW_WORDS_PER_DAY = 1;
export const MAX_NEW_WORDS_PER_DAY = 500;

/** The learner's daily limit for new words: `profile.new_words_per_day`, or 50 when it is not set. */
export function newWordsPerDay(
  profile: Pick<Profile, 'new_words_per_day'> | null | undefined
): number {
  const value = profile?.new_words_per_day;
  return typeof value === 'number' && Number.isFinite(value)
    ? Math.min(MAX_NEW_WORDS_PER_DAY, Math.max(MIN_NEW_WORDS_PER_DAY, Math.floor(value)))
    : DEFAULT_NEW_WORDS_PER_DAY;
}
